import React from 'react';
import { ActionPopover } from 'components/ActionPopover';
import { Box } from '@mui/material';
import { Edit, Inventory } from '@mui/icons-material';

export const CalendarMeetingTemplateActions = ({
  id,
  onEdit,
  onArchive,
  editBlockedReason
}: {
  id: string;
  onEdit: () => void;
  onArchive: () => void;
  editBlockedReason?: string | null;
}) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <ActionPopover
        id={id}
        options={[
          {
            label: editBlockedReason
              ? "Can't edit — organiser unavailable"
              : 'Edit',
            onClick: onEdit,
            icon: <Edit />,
            disabled: !!editBlockedReason
          },
          { label: 'Archive', onClick: onArchive, icon: <Inventory /> }
        ]}
        iconSx={{ color: 'primary.main' }}
      />
    </Box>
  );
};
